// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1iKJZ","rootSuccess":"CompleteLink_rootSuccess__3_95y","rootFailure":"CompleteLink_rootFailure__338F6","isDisabled":"CompleteLink_isDisabled__IXSH5"};